module.exports = function () {
  var html = "\n    <div class=\"space-overlay\">\n      <div class=\"name\"></div>\n      <div class=\"units\"></div>\n      <div class=\"status\"></div>\n      <div class=\"control\"></div>\n    </div>\n  ";
  return html;
};